export default __webpack_public_path__ + "static/media/sl6-min.ae0de94c.jpg";